import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { ReactComponent as IrregularShapes } from "../assets1/circles.svg";


const markersDE = [
  {
    id: "path1",
    label: "Shape 1",
    pathId: "path1",
    question: "AP1: Projektleitung und Dissemination",
    answer: "Die Projektkoordination, das administrative Management, die Überwachung des definierten Arbeitsplans sowie die fristgerechte Projektdissemination und Veröffentlichung der Ergebnisse wird vom Lehrstuhl für Holzwissenschaft zusammen mit den jeweiligen Arbeitspaketleitern durchgeführt.",
    extra: "TUM, Lehrstuhl für Holzwissenschaft, Univ.-Prof. Dr. Klaus Richter",
    bearbeitung: "Florian Böhm M.Sc.",
  },
  {
    id: "path2",
    label: "Shape 2",
    pathId: "path2",
    question: "AP2: Entwicklung von Kriterien für die Planung kreislaufgerechter Holzbauten in Tafelbauweise auf Gebäudeebene/Nutzungsebene",
    answer:
      "Im Rahmen einer materialeffizienten und nachhaltigen Nutzung des Rohstoffs Holz spielt die Berücksichtigung der Langlebigkeit, Flexibilität und Rückbaubarkeit bereits in der Planungsphase eines Gebäudes eine entscheidende Rolle. Nutzungsflexible und anpassungsfähige Gebäude mit hoher Gebrauchsqualität bilden die Basis für einen ressourcenschonenden Umgang mit Raumbedarf. Um eine langfristige und somit auch nachhaltige Gebäudenutzung zu gewährleisten, muss bereits im Planungsprozess neben den Prinzipien der Rückbaubarkeit und der Verwendung gebrauchstauglicher Bauteile, die Flexibilität und Anpassbarkeit bis zum Ende der Lebensdauer des Gebäudes bedacht werden. Davon ausgehend, dass sich die Anforderungen der Nutzer bis zum Lebensende des Gebäudes (mehrfach) wandeln, muss eine strukturelle und funktionale Variabilität bereits bei der Planung vorgesehen werden, um eine Verlängerung der Gesamtnutzungsdauer zu gewährleisten. Diese Anforderungen umfassen neben entwerferischen Prinzipien der Nutzungsflexibilität auch die (versorgungs-) technischen Prinzipien der Systemtrennung. Daneben stehen die statisch-konstruktiven Anforderungen im Zusammenspiel mit einer reduzierten, aber robusten Primärkonstruktion. Ziel dieses Arbeitspaketes ist es, den Zusammenhang von kreislaufgerechten Konstruktionen und ihren Beitrag zur Nutzungsflexibilität und Modifikation von Gebäuden zu untersuchen. Es gilt zu zeigen, wie durch geeignete Kombination die Langlebigkeit sowohl von Gebäuden als auch von einzelnen Bauteilen und von Materialien positiv beeinflusst werden kann. Die Betrachtungen konzentrieren sich auf die Typologien Wohnen und Arbeiten und deren Kombination. Die Ergebnisse, sowohl auf räumlicher und struktureller Gebäudeebene, als auch auf technisch/konstruktiver Bauteilebene, werden in einem Kriterienkatalog zusammengeführt und in konkrete Handlungsempfehlungen überführt. Das AP 2 stellt die Grundlage für die Weiterbetrachtung auf Gebäude- und Bauteilebene von AP 3 dar. In einem iterativen Prozess findet eine Bewertung und Validierung der Zwischenergebnisse statt. Die Notwendigkeit der Integration semantischer Informationen in den Planungsprozess erfolgt im Austausch mit AP 5. Die konzeptionelle Ausarbeitung erfolgt in enger Zusammenarbeit mit den Industriepartnern.",
    extra: "TUM, Lehrstuhl für Architektur und Holzbau, Univ.-Prof. Stephan Birk",
    bearbeitung: "Dr.-Ing. Sandra Schuster, Dipl.-Ing. Tabea Huth M.Eng.",
  },
  {
    id: "path3",
    label: "Shape 3",
    pathId: "path3",
    question: "AP3: Entwicklung und Pilotumsetzung von kreislaufgerechten Holzbaukonstruktionen im Fertighausbau",
    answer:
      "Auf Bauteilebene sind Untersuchungsziel die Optimierung bestehender und der Entwicklung neuer Konstruktionen, Planungsansätzen und Prozessen für eine werterhaltende Rückgewinnung von Vollholz (und anderen Baustoffen). Dabei können vier Teilziele identifiziert werden: kreislaufgerechte Rückbaubarkeit, kreislaufgerechte Planung, kreislaufgerechte Konstruktionen sowie kreislaufgerechte Prozesse.",
    extra: "TUM, Lehrstuhl für Holzbau und Baukonstruktion, Univ.-Prof. Dr.-Ing. Stefan Winter",
    bearbeitung: "Zsofia Varga M.Sc.",
  },
  {
    id: "path4",
    label: "Shape 4",
    pathId: "path4",
    question: "AP4: Eigenschaften und Verwendbarkeit von Gebrauchtholzprodukten im Holzbau",
    answer:
      "Die Hauptaufgabe für den Lehrstuhl für Holzwissenschaft, vertreten durch den Forschungsbereich Stoffstrommanagement, liegt in der Ermittlung von Eigenschaften und Verwendbarkeit von Gebrauchtholzprodukten im Holzbau. Es gilt Gebrauchtholzeigenschaften zu charakterisieren, um Qualitätsverluste des Holzes während der Nutzphase und Abrissprozesse qualitativ und quantitativ darstellen zu können. Dabei werden aus dem aktuellen Stoffstrom von Gebrauchtholz potentielle Bauprodukte für den Holztafelbau identifiziert. Aufbauend auf Versuchsreihen an Holztafelelementen werden Empfehlungen zur Mindestqualität von Gebrauchtholz nach dem Rückbau abgeleitet. Als begleitende Untersuchung erfolgt die ökobilanzielle Bewertung der neuen kreislaufgerechten Holztafelbauelemente im Vergleich zum Status-quo.",
    extra: "TUM, Lehrstuhl für Holzwissenschaft, Univ.-Prof. Dr. Klaus Richter",
    bearbeitung: "Florian Böhm M.Sc.",
  },
  {
    id: "path5",
    label: "Shape 5",
    pathId: "path5",
    question: "AP5: Blockchainbasierter Materialpass",
    answer:
      "Ziel des AP 5 ist die Konzeption und prototypische Implementierung von digitalen Methoden für die kreislaufgerechte Konstruktion zur Entscheidungsunterstützung für die Bauindustrie, die Abfallwirtschaft und den Kapitalmarkt, um ein effektives Wertschöpfungsnetzwerk aufzubauen. Die Kopplung von Materialien auf der Blockchain (Smart-Contracts, Tokens) und die Darstellung von Lebenszyklusdaten (LCA) stehen im Mittelpunkt des AP 5. Die Zugriffsrechte auf die Daten in der Blockchain können eindeutig zugewiesen werden, wodurch ein dezentraler und fälschungssicherer Datenaustausch gewährleistet ist. Synergieeffekte zwischen der Forschungsgruppe und den Industriepartnern sollen genutzt werden, um etablierte Standards der Industrie 4.0 zu nutzen und mit LCA-Benchmarks in einem Materialpass zu verbinden. Im Rahmen dieser Zusammenarbeit werden neue Methoden in diesem speziellen Kontext entwickelt und veröffentlicht.",
    extra: "TUM, Lehrstuhl für Architekturinformatik, Univ.-Prof. Prof. Dr.-Ing. Frank Petzold",
    bearbeitung: "Jakob Fellner M.Sc.",
  },
  {
    id: "path6",
    label: "Shape 6",
    pathId: "path6",
    question: "AP6: Nachhaltigkeitsbewertung von kreislaufgerechten Holzbaukonstruktionen",
    answer:
      "Das Ziel des Arbeitspakets ist die ganzheitliche Bewertung der in AP 3 entwickelten Lösungen für kreislaufgerechte Holztafelkonstruktionen. Die Ressourceneffekte und ökologischen und ökonomischen Vorteile, die einer kreislaufgerechten Konstruktion zugesprochen werden, müssen erfasst und den ggf. höheren Aufwendungen in der Planungs- und Konstruktionsphase, dem Rückbau und der Gebrauchtholzaufbereitung gegenübergestellt werden. Dazu werden die in AP 3 entwickelten Konstruktionen ökobilanziell und ökonomisch bewertet. Die Kombination beider Bewertungsverfahren ermöglicht die Berechnung der Ökoeffizienz zur Identifikation von Trade-offs zwischen den ökonomischen und ökologischen Aspekten.",

    extra: "TUM, Professur für Circular Economy, Prof. Dr. Magnus Fröhling",
    bearbeitung: "Josef Huber M.Sc.",
  }
];

const markersEN = [
  {
    id: "path1",
    label: "Shape 1",
    pathId: "path1",
    question: "WP1: Project management and dissemination",
    answer: "The project coordination, the administrative management, the monitoring of the defined schedule as well as the project dissemination and publication of the results in time will be carried out by the Chair of Wood Science together with the respective work package leaders.",
    extra: "TUM, Lehrstuhl für Holzwissenschaft, Univ.-Prof. Dr. Klaus Richter",
    bearbeitung: "Florian Böhm M.Sc.",
  },
  {
    id: "path2",
    label: "Shape 2",
    pathId: "path2",
    question: "WP2: Development of criteria of planning circular wooden structures in panel construction at the building and usage level",
    answer: "In the context of a material-efficient and sustainable use of the raw material wood, the consideration of longevity, flexibility, and dismantling plays a decisive role in the planning phase of a building. Buildings that are flexible and adaptable with a high quality of use form the basis for dealing with space requirements in a way that conserves resources. To ensure long-term and sustainable building use, the principles of dismantling and using functional components, flexibility, and adaptability up to the end of the building's service life must already be considered during the planning process. Suppose user requirements will change (several times) until the end of the building's life. In that case, structural and functional variability must be provided for in the planning phase to ensure an extension of the overall service life. In addition to design principles of the flexibility of use, these requirements also include the technical (supply) principles of system separation. In addition, there are static-constructive requirements in combination with a reduced but robust primary construction. Work package two examines the connection between circular structures and their contribution to the flexibility of use and modification of buildings. The aim is to show how a suitable combination can positively influence the longevity of buildings, individual components, and materials. The observations focus on the typologies of living and working and their variety. The results, both at the spatial and structural level of the building and at the technical/constructive component level, are brought together in a catalog of criteria and converted into concrete recommendations for action. Work package two represents the basis for further consideration at the building level and level of work package three. The interim results are evaluated and validated in an iterative process. The necessity of integrating semantic information into the planning process takes place in exchange with work package five. The conceptual elaboration takes place in close cooperation with the industrial partners.",
    extra: "TUM, Lehrstuhl für Architektur und Holzbau, Univ.-Prof. Stephan Birk",
    bearbeitung: "Dr.-Ing. Sandra Schuster, Dipl.-Ing. Tabea Huth M.Eng.",
  },
  {
    id: "path3",
    label: "Shape 3",
    pathId: "path3",
    question: "WP3: Development of circular timber panel building constructions",
    answer: "At the element level, the aim of the study is to optimize existing and develop new constructions, planning approaches and processes for the value-preserving recovery of solid wood (and other building materials). Four sub-objectives can be identified: cycle-compatible deconstructability, cycle-compatible planning, cycle-compatible constructions and cycle-compatible processes.",    extra: "TUM, Lehrstuhl für Holzbau und Baukonstruktion, Univ.-Prof. Dr.-Ing. Stefan Winter",
    bearbeitung: "Zsofia Varga M.Sc.",
  },
  {
    id: "path4",
    label: "Shape 4",
    pathId: "path4",
    question: "WP4: Properties and usability of used wood products in timber construction",
    answer: "The main task for the Chair of Wood Science, represented by the research area Material Flow Management, is to determine the properties and usability of used wood products in timber construction. The aim is to characterize used wood properties in order to be able to qualitatively and quantitatively represent losses of the quality of the wood during the demolition processes and recovery processes. Potential building products for timber panel construction are identified from the current material flow of used wood. In parallel, the environmental impacts of the circular timber panel elements in comparison to the status-quo are analyzed using life cycle based assessment methods. Based on test series, recommendations for the minimum quality of used wood after deconstruction are derived.",
    extra: "TUM, Lehrstuhl für Holzwissenschaft, Univ.-Prof. Dr. Klaus Richter",
    bearbeitung: "Florian Böhm M.Sc.",
  },
  {
    id: "path5",
    label: "Shape 5",
    pathId: "path5",
    question: "WP5: Blockchain-based material passport",
    answer: "The goal of WP 5 is the conception and prototypical implementation of digital methods for circular construction for decision support for the construction industry, waste management, and the capital market to build an effective value network. The coupling of materials on the blockchain (smart contracts, tokens) and the representation of life cycle assessment (LCA) data are the focus of WP 5. Users can uniquely assign access rights to data on the blockchain, thus ensuring decentralized and tamper-proof data exchange. Synergy effects between the research group and the industrial partners will be used to leverage established Industrie 4.0 standards and combine them with LCA benchmarks in a material passport. New methods in this specific context will be developed and published as part of this collaboration.",
    extra: "TUM, Lehrstuhl für Architekturinformatik, Univ.-Prof. Prof. Dr.-Ing. Frank Petzold",
    bearbeitung: "Jakob Fellner M.Sc.",
  },
  {
    id: "path6",
    label: "Shape 6",
    pathId: "path6",
    question: "WP6: Sustainability assessment of circular timber constructions",
    answer: "The aim of the work package is the holistic evaluation of solutions developed in WP 3 for circular timber panel constructions. The resource effects and ecological and economic advantages that are attributed to a closed-loop construction must be recorded and compared to the possibly higher expenses in the planning and construction phase, the deconstruction and the used wood processing. For this purpose, the constructions developed in WP 3 are evaluated ecologically and economically. The combination of both assessment methods enables the calculation of the eco-efficiency to identify trade-offs between the economic and ecological aspects.",
    extra: "TUM, Professur für Circular Economy, Prof. Dr. Magnus Fröhling",
    bearbeitung: "Josef Huber, M.Sc.",
  }
];

const AccordionComponent = (probs) => {

  // Import Language
  const { language } = probs;
  const markers = language === "de" ? markersDE : markersEN;

  const contentDe = {
    researchTitle: "Forschung",
    researchText: "Das Gesamtziel des Vorhabens ist daher die Entwicklung von kreislaufgerechten Holztafelbaukonstruktionen unter der Prämisse einer formalen, technischen, ökonomischen und ökologischen Realisierbarkeit. Die",

    workPackagesTitle: "Arbeitspakete",
    workPackagesText: "TextDE...",
  };

  const contentEn = {
    researchTitle: "Research",
    researchText: "The overall goal of the project is therefore the development of circular timber panel construction under the premise of formal, technical, economic and ecological feasibility. The",

    workPackagesTitle: "Work Packages",
    workPackagesText: "TextEN...",
  };

  const content = language === "de" ? contentDe : contentEn;


  // Lang Switch Lehrstuhl
  const contentLehrstuhlDe = "Lehrstuhl";
  const contentLehrstuhlEn = "Chair";
  const contentLehrstuhl = language === "de" ? contentLehrstuhlDe : contentLehrstuhlEn;

  // Lang Switch Projektbearbeitung
  const contentProjektBearbeitungDe = "Projektbearbeitung";
  const contentProjektBearbeitungEn = "Project Team";
  const contentProjektBearbeitung = language === "de" ? contentProjektBearbeitungDe : contentProjektBearbeitungEn;


  //Start Accordion
  const [selectedMarkerID, setSelectedMarkerID] = useState(null);
  

  const handleMarkerPressed = (id) => () => {
    if (selectedMarkerID === id) {
      setSelectedMarkerID(null);
    } else {
      setSelectedMarkerID(id);
    }
  };

  const handleShapeMouseOver = (event) => {
    const id = event.target.id || event.target.parentNode.id;
    const marker = markers.find((marker) => marker.id === id);
    if (marker) {
      setSelectedMarkerID(marker.id);
      const path = document.getElementById(marker.pathId);
      if (path) {
        path.classList.add("glow");
      }
    }
  };

  const handleShapeMouseOut = (event) => {
    const id = event.target.id || event.target.parentNode.id;
    const marker = markers.find((marker) => marker.id === id);
    if (marker) {
      setSelectedMarkerID(marker.id);
      // This is the original code; Wenn die Maus über das Accordion fährt, wird der Marker nicht mehr ausgeblendet
      //setSelectedMarkerID(null);
      //
      const path = document.getElementById(marker.pathId);
      if (path) {
        path.classList.remove("glow");
      }
    }
  };

  return (
    <Stack
      //px={{ xs: "2%", sm: "7%" }}
      flexDirection={{ xs: "column", sm: "column", md: "column", xl: "row" }}
      //py={{ xs: "25px", sm: "40px", md: "50px" }}
      px={{ xs: "2%", sm: "7%" }}
      display='flex'
    >
      <Box 
      
      //width={"50%"}
      paddingRight={{ xs: "0%", sm: "0%", md: "6%" }} 
      sx={{ order: 1 }}
      ml={{ xs: "12.5%", sm: "12.5%", md: "12.5%", xl: "0%" }}
      width={{ xs: "75%", sm: "75%", md: "75%", xl: "50%" }}     
      >
        <div id={content.workPackagesTitle}></div><br /><br /><br />
        
        <Typography
          variant="h2"
          fontWeight="800"
          fontSize={{ xs: "28px", sm: "34px", md: "44px" }}
          //mb={{ xs: "15px", sm: "25px" }}
        >
          {content.workPackagesTitle} <br />
        </Typography>
        
        <IrregularShapes
          className="irregular-shapes"
          onMouseOver={handleShapeMouseOver}
          onMouseOut={handleShapeMouseOut}
          //onMouseDown={handleAccordionChange}
          //height={"650px"}
          width={"100%"}
          //preserveAspectRatio="xMinYMin slice" 
        >
          {markers.map((marker) => (
            <path
              key={marker.id}
              id={marker.id}
              d={marker.d}
            />
          ))}
        </IrregularShapes>
    
      </Box>
      <Box 
        width={{ xs: "100%", sm: "100%", md: "100%", xl: "50%" }}
        py={{ xs: "0px", sm: "0px", md: "0px", xl: "150px" }}
        sx={{ order: 2, mt: { xs: 0, sm: 7 } }}     
      >
        {markers.map((marker) => (
          <Accordion
            sx={{ boxShadow: "none", my: { xs: "10px", sm: "20px" } }}
            key={marker.id}
            id={`accordion-${marker.id}`}
            expanded={selectedMarkerID === marker.id}
            onChange={handleMarkerPressed(marker.id)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1" fontWeight="500">
                {marker.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{marker.answer}</Typography>
            </AccordionDetails>
            <AccordionDetails>
              <Typography variant="body1"><b>{contentLehrstuhl}</b> {marker.extra}</Typography>
            </AccordionDetails>
            <AccordionDetails>
              <Typography variant="body1"><b>{contentProjektBearbeitung}</b> {marker.bearbeitung}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Stack>
  );
};
export default AccordionComponent;
